import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/item-removal/page.tsx");
